interface IParsedMimeType {
  type: string;
  subtype: string;
}

function parseMimeType(mimeType: string): IParsedMimeType {
  const [type, subtype] = mimeType.toLowerCase().split('/');

  return {
    type,
    subtype,
  };
}

function getType(mimeType: string): string {
  return mimeType && parseMimeType(mimeType).type;
}

function isAudio(mimeType: string) {
  return getType(mimeType) === 'audio';
}

function isVideo(mimeType: string) {
  return getType(mimeType) === 'video';
}

export { getType, isAudio, isVideo };
